export const CLINICS = [
  {
    slug: "ribeira-brava",
    nome: "Vet Clinic Ribeira Brava",
    nomeOficial: "Clínica Veterinária da Ribeira Brava",
    morada: "Rua de São Pedro, Edifício Belo Vale, Loja A",
    codigoPostal: "9350-139",
    cidade: "Ribeira Brava",
    telefone: "291 676 284",
    telefoneE164: "+351291676284",
    horarioResumo: "Seg–Sex 9h–18h • Sáb 9h–13h",
    googleRating: 4.5,
    googleReviews: 86,
  },
  {
    slug: "calheta",
    nome: "Vet Clinic Calheta",
    nomeOficial: "Consultório Veterinário da Estrela da Calheta",
    morada: "Estrada Simão Gonçalves Câmara, nº 84, E.R. 224 – Lombo da Estrela",
    codigoPostal: "9370-139",
    cidade: "Calheta",
    telefone: "291 827 677",
    telefoneE164: "+351291827677",
    horarioResumo: "Consultas Seg–Sáb 9h30–13h • Espaço 9h–13h e 14h–17h30",
  },
];

export const TELEMOVEL_GERAL = "965 650 700";
export const TELEMOVEL_GERAL_E164 = "+351965650700";

export const SOCIAIS = {
  instagram: "https://www.instagram.com/vetclinic.rbrava.calheta/",
  facebookRibeira: "https://www.facebook.com/profile.php?id=100057400332928",
  facebookCalheta: "https://www.facebook.com/profile.php?id=100055980047563",
  email: "geral@vetclinic.pt",
};
